(() => {
  const iconMarkup = (name) => {
    if (name && name.startsWith('swatch-')) {
      const color = name.replace('swatch-', '');
      return `<span class="self-fit-quiz-modal__swatch self-fit-quiz-modal__swatch--${color}" aria-hidden="true"></span>`;
    }

    const icons = {
      hanger: '<path d="M8 7.5c0-1.2 1.2-1.4 1.2-2.5A2.2 2.2 0 0 0 7 2.8 2.2 2.2 0 0 0 4.8 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M8 7.5 2.7 11c-.7.5-.4 1.6.5 1.6h9.6c.9 0 1.2-1.1.5-1.6L8 7.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
      sparkle: '<path d="M8 1.8 9.8 6 14 8l-4.2 2L8 14.2 6.2 10 2 8l4.2-2L8 1.8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
      briefcase: '<path d="M5.2 5V3.8c0-.8.6-1.4 1.4-1.4h2.8c.8 0 1.4.6 1.4 1.4V5" stroke="currentColor" stroke-width="1.6"/><path d="M2.4 5h11.2v7.8H2.4V5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M2.4 8.4h11.2" stroke="currentColor" stroke-width="1.6"/>',
      star: '<path d="m8 2.2 1.7 3.4 3.8.6-2.8 2.7.7 3.8L8 10.9l-3.4 1.8.7-3.8-2.8-2.7 3.8-.6L8 2.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
      heart: '<path d="M8 13.4S2.8 10.3 2.8 6.4A2.8 2.8 0 0 1 8 4.9a2.8 2.8 0 0 1 5.2 1.5c0 3.9-5.2 7-5.2 7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
      support: '<path d="M3 3.2v6.1A3.7 3.7 0 0 0 6.7 13h2.6A3.7 3.7 0 0 0 13 9.3V3.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M5 4.4h6M5 7h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      curve: '<path d="M4.3 2.8c-.8 2-.9 4-.4 5.8.5 2 2.2 3.8 4.1 4.6 1.9-.8 3.6-2.6 4.1-4.6.5-1.8.4-3.8-.4-5.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M5.8 6.4h4.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      shape: '<path d="M5 2.5c.4 1.4.8 2.6.8 4.1S5.4 9.4 5 10.8c1.2 1 4.8 1 6 0-.4-1.4-.8-2.7-.8-4.2s.4-2.7.8-4.1" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5 10.8V14h6v-3.2" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
      soft: '<path d="M4 8c0-3 4-5.7 8-5.7 0 4-2.7 8-5.7 8H4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M4 13c1.6-3 4.1-5 7-6.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      tag: '<path d="M2.7 8.5V3.2h5.3l5.3 5.3-5.3 5.3-5.3-5.3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5.8 5.8h.1" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>',
      tummy: '<path d="M5 2.6c1.9 1.1 4.1 1.1 6 0 .7 1.8.7 3.7.2 5.6-.5 2-1.6 3.8-3.2 5.2-1.6-1.4-2.7-3.2-3.2-5.2-.5-1.9-.5-3.8.2-5.6Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5.4 7.5h5.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      waist: '<path d="M5 2.5c.6 1.6.9 3 .9 4.2 0 1.3-.3 2.6-.9 4.2 1.4 1 4.6 1 6 0-.6-1.6-.9-2.9-.9-4.2 0-1.2.3-2.6.9-4.2" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M5.8 6.8h4.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      hips: '<path d="M4.4 3.1c-.4 1.7-.3 3.6.2 5.5.5 1.8 1.7 3.4 3.4 4.3 1.7-.9 2.9-2.5 3.4-4.3.5-1.9.6-3.8.2-5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.3 9.3c1.7.8 3.7.8 5.4 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      thighs: '<path d="M6 2.8c-.7 2.2-.8 4.6-.4 7.3l.5 3.1M10 2.8c.7 2.2.8 4.6.4 7.3l-.5 3.1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M6 7.8h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      bust: '<path d="M3.5 4.8v3.4A3.3 3.3 0 0 0 6.8 11.5h2.4a3.3 3.3 0 0 0 3.3-3.3V4.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M4.8 5.5c1.1.9 2 .9 3.2 0 1.2.9 2.1.9 3.2 0M5 12.8h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
      backarea: '<path d="M4.5 3.4c1.8 1 5.2 1 7 0v5.2c0 2-1.5 3.9-3.5 4.8-2-.9-3.5-2.8-3.5-4.8V3.4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M8 4.4v8M5.2 8.1h5.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
    };

    return `<svg viewBox="0 0 16 16" fill="none" focusable="false" aria-hidden="true">${icons[name] || icons.sparkle}</svg>`;
  };

  const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const focusableSelector = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  document.querySelectorAll('[data-self-fit-quiz-root]').forEach((root) => {
    const openButton = root.querySelector('[data-self-fit-quiz-open]');
    const modal = root.querySelector('[data-self-fit-quiz]');
    const panel = root.querySelector('.self-fit-quiz-modal__panel');
    const config = root.querySelector('[data-self-fit-quiz-config]');
    if (!openButton || !modal || !panel || !config) return;

    let quizConfig = {};
    let steps = [];
    try {
      quizConfig = JSON.parse(config.textContent) || {};
      steps = quizConfig.steps || [];
    } catch (error) {
      quizConfig = {};
      steps = [];
    }
    if (!steps.length) return;

    const resultConfig = quizConfig.result || null;

    const title = root.querySelector('[data-self-fit-quiz-title]');
    const helper = root.querySelector('[data-self-fit-quiz-helper]');
    const optionsWrap = root.querySelector('[data-self-fit-quiz-options]');
    const count = root.querySelector('[data-self-fit-quiz-count]');
    const bar = root.querySelector('[data-self-fit-quiz-bar]');
    const nextButtons = root.querySelectorAll('[data-self-fit-quiz-next]');
    const prevButtons = root.querySelectorAll('[data-self-fit-quiz-prev]');
    const closeButtons = root.querySelectorAll('[data-self-fit-quiz-close]');
    const resultActions = root.querySelector('[data-self-fit-quiz-result-actions]');
    const answers = new Array(steps.length).fill(null);
    let index = 0;
    let lastFocus = null;
    let isResult = false;

    const selected = () => answers[index];

    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const getRecommendedProducts = () => {
      const pools = (resultConfig && resultConfig.pools) || {};
      const productType = answers[2] || 'All';
      const primaryPool = pools[productType] || [];
      const fallbackPool = pools.All || [];
      // A selected semi-category is authoritative. Only the explicit All
      // choice may use the all-products pool.
      const sourcePool = productType === 'All' ? fallbackPool : primaryPool;
      const combined = sourcePool.filter((product, productIndex, products) => {
        const url = product && product.url;
        return product && url && products.findIndex((item) => item && item.url === url) === productIndex;
      });

      const scoringTerms = [
        answers[0],
        answers[1],
        answers[2],
        answers[3],
        answers[4]
      ].map(normalize).filter(Boolean);

      const scoredProducts = combined.map((product, productIndex) => {
        const searchable = normalize([
          product.title,
          ...(Array.isArray(product.tags) ? product.tags : [])
        ].join(' '));
        const score = scoringTerms.reduce((total, term) => total + (term && searchable.includes(term) ? 1 : 0), 0);
        return { product, productIndex, score };
      });

      return scoredProducts
        .sort((a, b) => b.score - a.score || a.productIndex - b.productIndex)
        .slice(0, 3)
        .map((item) => item.product);
    };

    const getResultHelper = () => {
      const support = answers[3] || 'everyday';
      const compression = answers[4] || 'medium';
      const productType = answers[2] || 'products';
      return `We selected these ${productType.toLowerCase()} based on your preference for ${support.toLowerCase()} comfort and ${compression.toLowerCase()} support.`;
    };

    const safeColor = (value, fallback = '#AC5F35') => {
      const color = String(value || '').trim();
      return /^#[0-9a-f]{3,8}$/i.test(color) ? color : fallback;
    };

    const render = () => {
      isResult = false;
      const step = steps[index];
      panel.dataset.step = String(index + 1);
      panel.dataset.state = 'question';
      panel.dataset.layout = step.layout || '';
      if (resultActions) resultActions.hidden = true;
      title.textContent = step.title;
      helper.textContent = step.helper || '';
      helper.hidden = !step.helper;
      count.textContent = `${index + 1}/${steps.length}`;
      bar.style.width = `${(step.progress || ((index + 1) / steps.length)) * 100}%`;

      optionsWrap.innerHTML = step.options.map((option) => {
        const isSelected = selected() === option.label;
        const label = escapeHtml(option.label);
        let media = '';
        if (step.layout === 'size-known') {
          media = '<span class="self-fit-quiz-modal__radio" aria-hidden="true"></span>';
        } else if (option.iconImage) {
          media = `<span class="self-fit-quiz-modal__option-icon self-fit-quiz-modal__option-icon--image"><img src="${escapeHtml(option.iconImage)}" alt="" loading="lazy"></span>`;
        } else if (option.assetIcon) {
          media = `<span class="self-fit-quiz-modal__option-icon self-fit-quiz-modal__option-icon--image"><img src="${escapeHtml(option.assetIcon)}" alt="" loading="lazy"></span>`;
        } else if (option.image) {
          media = `<span class="self-fit-quiz-modal__option-image"><img src="${escapeHtml(option.image)}" alt="" loading="lazy"></span>`;
        } else {
          media = `<span class="self-fit-quiz-modal__option-icon">${iconMarkup(option.icon)}</span>`;
        }
        return `
          <button
            class="self-fit-quiz-modal__option${isSelected ? ' is-selected' : ''}"
            type="button"
            data-self-fit-quiz-option="${label}"
            aria-pressed="${isSelected ? 'true' : 'false'}"
          >
            ${media}
            <span class="self-fit-quiz-modal__option-label">${label}</span>
          </button>
        `;
      }).join('');

      const hasSelection = Boolean(selected());
      nextButtons.forEach((button) => {
        button.disabled = !hasSelection;
        button.textContent = step.nextLabel || (index === steps.length - 1 ? 'Shop Match' : 'Next');
      });
      prevButtons.forEach((button) => {
        button.disabled = index === 0;
      });
    };

    const renderResults = () => {
      if (!resultConfig) return;
      isResult = true;
      panel.dataset.step = 'result';
      panel.dataset.state = 'result';
      panel.dataset.layout = 'quiz-results';
      if (resultActions) resultActions.hidden = false;
      title.textContent = resultConfig.title || '';
      helper.textContent = getResultHelper();
      helper.hidden = false;
      count.textContent = '';
      bar.style.width = '100%';

      const products = getRecommendedProducts();
      const fallbackImage = resultConfig.fallbackImage || '';

      optionsWrap.innerHTML = products.map((product) => {
        const productTitle = escapeHtml(product.title || '');
        const productUrl = escapeHtml(product.url || '/collections/all');
        const productImage = escapeHtml(product.image || fallbackImage);
        const productPrice = escapeHtml(product.price || '');
        const productCurrency = escapeHtml(product.currency || '');
        const swatches = (Array.isArray(product.swatches) && product.swatches.length ? product.swatches : [
          { name: 'Brown', color: '#AC5F35' },
          { name: 'White', color: '#FFFFFF' },
          { name: 'Blue', color: '#38BDF8' }
        ]).slice(0, 3).map((swatch) => {
          const color = safeColor(swatch.color);
          const name = escapeHtml(swatch.name || 'Color');
          return `<span class="self-fit-quiz-result-card__swatch" title="${name}" style="--swatch-color: ${color};" aria-hidden="true"></span>`;
        }).join('');

        return `
          <article class="self-fit-quiz-result-card">
            <a class="self-fit-quiz-result-card__media" href="${productUrl}" aria-label="${productTitle}">
              <img src="${productImage}" alt="${productTitle}" loading="lazy">
            </a>
            <div class="self-fit-quiz-result-card__info">
              <a class="self-fit-quiz-result-card__title" href="${productUrl}">${productTitle}</a>
              <a class="self-fit-quiz-result-card__price" href="${productUrl}">
                <span>${productPrice}</span>
                <small>${productCurrency}</small>
              </a>
              <div class="self-fit-quiz-result-card__swatches" aria-label="Available colors">${swatches}</div>
            </div>
          </article>
        `;
      }).join('');

      nextButtons.forEach((button) => {
        button.disabled = true;
        button.textContent = 'Next';
      });
      prevButtons.forEach((button) => {
        button.disabled = false;
      });
    };

    const getResultUrl = () => {
      const stepOption = steps[index].options.find((option) => option.label === selected());
      if (stepOption && stepOption.collection) return stepOption.collection;
      const firstStepOption = steps[0].options.find((option) => option.label === answers[0]);
      return (firstStepOption && firstStepOption.collection) || '/collections/all';
    };

    const open = () => {
      lastFocus = document.activeElement;
      isResult = false;
      index = 0;
      modal.hidden = false;
      document.body.classList.add('self-fit-quiz-lock');
      render();
      requestAnimationFrame(() => panel.focus());
      document.addEventListener('keydown', onKeydown);
    };

    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('self-fit-quiz-lock');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    const next = () => {
      if (!selected()) return;
      if (index === steps.length - 1) {
        const stepOption = steps[index].options.find((option) => option.label === selected());
        if (stepOption && stepOption.action === 'results') {
          renderResults();
          return;
        }
        if (stepOption && stepOption.action === 'redirect' && stepOption.url) {
          window.location.href = stepOption.url;
          return;
        }
        if (stepOption && stepOption.action === 'none') {
          return;
        }
        window.location.href = getResultUrl();
        return;
      }
      index += 1;
      render();
    };

    const prev = () => {
      if (isResult) {
        render();
        return;
      }
      if (index === 0) return;
      index -= 1;
      render();
    };

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = [...panel.querySelectorAll(focusableSelector)];
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
    prevButtons.forEach((button) => button.addEventListener('click', prev));
    nextButtons.forEach((button) => button.addEventListener('click', next));
    optionsWrap.addEventListener('click', (event) => {
      const optionButton = event.target.closest('[data-self-fit-quiz-option]');
      if (!optionButton) return;
      answers[index] = optionButton.dataset.selfFitQuizOption;
      render();
    });
  });
})();
